import { REQUEST_STATUSES } from "../constants";
import instance, { api } from "./instance";
import { getFileExt } from "../utils/fileUtils";
import { getErrorResponse } from "../utils/helper";

export class UploadService {
  static async uploadProfile(file) {
    try {
      const resp = await api({
        method: "post",
        url: "/api/v2/uploads/users",
        data: { fileName: `${crypto.randomUUID()}.${getFileExt(file.name)}` },
      });

      const [, key] = await Promise.all([
        instance({
          method: "put",
          url: resp.data.url,
          data: file,
          headers: {
            "Content-Type": file.type,
          },
        }),
        resp.data.key,
      ]);

      return {
        resp: { url: key },
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async uploadIcon(propertyId, file) {
    try {
      const resp = await api({
        method: "post",
        url: `/api/v2/uploads/icons/${propertyId}`,
        data: { fileName: `${crypto.randomUUID()}.${getFileExt(file.name)}` },
      });

      const [, key] = await Promise.all([
        instance({
          method: "put",
          url: resp.data.url,
          data: file,
          headers: {
            "Content-Type": file.type,
          },
        }),
        resp.data.key,
      ]);

      return {
        resp: { url: key },
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async uploadBrandingFile(propertyId, file) {
    try {
      const resp = await api({
        method: "post",
        url: `/api/v2/uploads/branding/${propertyId}`,
        data: { fileName: `${crypto.randomUUID()}.${getFileExt(file.name)}` },
      });

      const [, key] = await Promise.all([
        instance({
          method: "put",
          url: resp.data.url,
          data: file,
          headers: {
            "Content-Type": file.type,
          },
        }),
        resp.data.key,
      ]);

      return {
        resp: { url: key },
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async uploadElementFile(propertyId, file, onUploadProgress) {
    try {
      const resp = await api({
        method: "post",
        url: `/api/v2/uploads/elements/${propertyId}`,
        data: { fileName: `${crypto.randomUUID()}.${getFileExt(file.name)}` },
      });

      const [, key] = await Promise.all([
        instance({
          method: "put",
          url: resp.data.url,
          data: file,
          headers: {
            "Content-Type": file.type,
          },
          onUploadProgress,
        }),
        resp.data.key,
      ]);

      return {
        resp: { url: key },
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }

  static async uploadMediaItem(propertyId, file) {
    try {
      const resp = await api({
        method: "post",
        url: `/api/v2/uploads/media-items/${propertyId}`,
        data: { fileName: `${crypto.randomUUID()}.${getFileExt(file.name)}` },
      });

      const [, key] = await Promise.all([
        instance({
          method: "put",
          url: resp.data.url,
          data: file,
          headers: {
            "Content-Type": file.type,
          },
        }),
        resp.data.key,
      ]);

      return {
        resp: { url: key },
        err: null,
        status: REQUEST_STATUSES.SUCCEEDED,
      };
    } catch (err) {
      return {
        resp: null,
        err: getErrorResponse(err),
        status: REQUEST_STATUSES.FAILED,
      };
    }
  }
}
